module.exports = __webpack_public_path__ + "static/media/bicolorana_bicolor_004_APA.2c3b4541.png";